export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      title: 'Contáctanos',
      description: 'Envíanos un mensaje por WhatsApp o llena el formulario para decirnos qué servicio necesitas.',
      icon: 'ri-message-3-line',
      color: 'bg-blue-500'
    },
    {
      number: '2',
      title: 'Te guiamos en el proceso',
      description: 'Nuestro equipo te explica paso a paso los requisitos y documentos necesarios para tu trámite.',
      icon: 'ri-guide-line',
      color: 'bg-green-500'
    },
    {
      number: '3',
      title: 'Tu trámite queda listo',
      description: 'Nos encargamos del proceso para que puedas enfocarte en tu negocio y avanzar con tranquilidad.',
      icon: 'ri-checkbox-circle-line',
      color: 'bg-teal-500'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-blue-50/30 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            ¿Cómo funciona?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tres pasos simples para comenzar tu negocio
          </p>
          <div className="w-24 h-1 bg-blue-600 mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connection Lines */}
          <div className="hidden md:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 via-green-500 to-teal-500 opacity-20" style={{ top: '6rem' }}></div>

          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-lg p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 text-center">
                {/* Step Number Circle */}
                <div className={`w-20 h-20 ${step.color} rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg relative z-10`}>
                  <span className="text-3xl font-bold text-white">{step.number}</span>
                </div>

                {/* Icon */}
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mx-auto mb-6">
                  <i className={`${step.icon} text-3xl text-gray-700`}></i>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}